module.exports = __webpack_public_path__ + "static/media/grownetwork.a86cc10d.png";